import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { TranslatePipe } from '@ngx-translate/core';
import { DropdownComponent } from '../../../dropdown/dropdown.component';

@Component({
  selector: 'app-application-filter-dialog',
  templateUrl: './application-filter-dialog.component.html',
  styleUrls: ['./application-filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, DropdownComponent, MatDialogActions, TranslatePipe],
})
export class ApplicationFilterDialogComponent {
  dialogRef = inject<MatDialogRef<ApplicationFilterDialogComponent>>(MatDialogRef);

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public save(): void {
    // TODO
  }

  public handleChange(): void {
    // TODO
  }
}
